import { useState } from "react";
import { Clock, Gauge, type LucideIcon } from "lucide-react";
import { cn } from "../../lib/utils";
import { ConcurrencySection } from "./concurrency-section";
import { OffHoursSection } from "./off-hours-section";

const SECTIONS: { id: string; label: string; icon: LucideIcon }[] = [
  { id: "off-hours", label: "Off-Hours", icon: Clock },
  { id: "concurrency", label: "Concurrency", icon: Gauge },
];

export function AdminSettingsPage() {
  const [section, setSection] = useState("off-hours");

  return (
    <div className="space-y-6 p-8">
      <div>
        <h1 className="text-3xl font-bold text-ink">Admin Settings</h1>
        <p className="mt-1 text-sm text-ink-2">
          Global controls that apply across the platform. Rarely-changed settings live here
          rather than on the operational dashboards.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
        {/* Section nav */}
        <nav className="h-fit rounded-xl border border-line bg-elevated p-2 shadow-sm lg:sticky lg:top-8">
          {SECTIONS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setSection(id)}
              className={cn(
                "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors",
                section === id ? "bg-brand-soft font-semibold text-brand" : "text-ink-2 hover:bg-soft hover:text-ink",
              )}
            >
              <Icon className="h-4 w-4" /> {label}
            </button>
          ))}
        </nav>

        {/* Content */}
        <div className="lg:col-span-3">
          {section === "off-hours" && <OffHoursSection />}
          {section === "concurrency" && <ConcurrencySection />}
        </div>
      </div>
    </div>
  );
}
